import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../../../../assets/tractorTypes/ThreeAxleTractorSingleAxleSemitrailer.svg'


const _withScopeId = n => (_pushScopeId("data-v-a683f658"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"410px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "image"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"position":"absolute","top":"350px","left":"20px"} }, [
  /*#__PURE__*/_createElementVNode("div", null, "Вес нетто"),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"25px"} }, "Макс. вес")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IntegerControl = _resolveComponent("IntegerControl")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distance, (element, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("div", {
          style: _normalizeStyle(`position: absolute; top: ${element.top}px; left: ${element.left}px`)
        }, [
          _createVNode(_component_IntegerControl, {
            class: "TractorDistance-control",
            stylingMode: "outlined",
            min: 0,
            width: `${element.width}px`,
            showSpinButtons: false,
            value: _ctx.modelLocal[element.name],
            "onUpdate:value": ($event: any) => ((_ctx.modelLocal[element.name]) = $event)
          }, null, 8, ["width", "value", "onUpdate:value"])
        ], 4)
      ]))
    }), 128)),
    _hoisted_3,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weight, (element, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("div", {
          style: _normalizeStyle(`position: absolute; top: ${element.top}px; left: ${element.left}px`)
        }, [
          _createVNode(_component_IntegerControl, {
            class: "TractorWeight-control",
            stylingMode: "outlined",
            min: 0,
            max: 99999,
            width: "65px",
            value: _ctx.modelLocal[`${element.name}Weight`],
            "onUpdate:value": ($event: any) => ((_ctx.modelLocal[`${element.name}Weight`]) = $event)
          }, null, 8, ["value", "onUpdate:value"]),
          _createVNode(_component_IntegerControl, {
            class: "TractorWeight-control",
            style: {"margin-top":"10px"},
            stylingMode: "outlined",
            min: 0,
            max: 99999,
            width: "65px",
            value: _ctx.modelLocal[`${element.name}MaxWeight`],
            "onUpdate:value": ($event: any) => ((_ctx.modelLocal[`${element.name}MaxWeight`]) = $event)
          }, null, 8, ["value", "onUpdate:value"])
        ], 4)
      ]))
    }), 128))
  ]))
}